import React from 'react';

import {Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';

import {AlertInfo} from 'presentation/components';
import {NetworkTypesEnum} from 'domain/usecases';
import {useUnitList} from '../../hooks/useUnitList';
import {EmptySelfNetworkAlertProps} from './types';

const {selfNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function EmptySelfNetworAlert({list, flowType}: EmptySelfNetworkAlertProps) {
	const {getEmptySelfNetworkAlertDescription} = useUnitList({
		list,
		flowType,
		networkType: NetworkTypesEnum.SELF,
	});

	return (
		<Stack gap={1}>
			<Typography variant="subtitle1" color="text.secondary" fontWeight={600}>
				{selfNetwork.title}
			</Typography>
			<AlertInfo.Root>
				<AlertInfo.Description>
					{getEmptySelfNetworkAlertDescription()}
				</AlertInfo.Description>
			</AlertInfo.Root>
		</Stack>
	);
}
